import { useEffect, useState } from 'react';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef } from '@backstage/plugin-catalog-react';

export const useComponentTypes = () => {
  const [options, setOptions] = useState<string[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  const catalogApi = useApi(catalogApiRef);

  useEffect(() => {
    async function fetchComponentTypes() {
      try {
        setLoading(true);
        // Fetch all Component entities
        const { items } = await catalogApi.getEntities({
          filter: { kind: 'Component' },
        });

        // Extract unique spec.type values
        const types = Array.from(
          new Set(
            items
              .map(item => item.spec?.type)
              .filter((type): type is string => typeof type === 'string'),
          ),
        ).sort();

        setOptions(types);
        setError(null);
      } catch (err) {
        setError(err instanceof Error ? err : new Error('Unknown error'));
        console.error('Error fetching component types', err);
      } finally {
        setLoading(false);
      }
    }

    fetchComponentTypes();
  }, [catalogApi]);

  return { options, loading, error };
};
